export const portfolioCommentaryPageBaseQueryKey = "portfolioCommentaryPage";
